import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SharpenProduct, SharpenProductState } from "./sharpen-product.interface";
import { defaultApiState } from "../../../common/constants/api-constants";
import { StoreState } from "../../../store/store.interface";
import { ActionStatus } from "../../../common/constants/action-status";
import { loadCustomer } from "../../customer/customer";
import { ShopApi } from "../../../common/constants/shop-api";
import getCookie, { COOKIE_MH_TOKEN } from "../../../common/cookies";
import environment from "../../../common/environment";
import { getResponseData } from "../../../common/utils/api-utils";

export const sharpenProductInitialState: SharpenProductState = defaultApiState;


// CREATE SELECTOR
export const getSharpenProductUrl = (state: StoreState) => {
    const sharpenProduct = state.sharpenProductState;
    if(sharpenProduct.status == ActionStatus.succeeded && sharpenProduct.data){
        return sharpenProduct.data.url;
    }
    return '';
}


// CREATE STORE SLICE
export const sharpenProductSlice = createSlice({
    name: "sharpenProduct",
    initialState: sharpenProductInitialState,
    reducers:{},
    extraReducers(builder) {
      builder
      .addCase(getSharpenProduct.pending, (state) => {
        state.status = ActionStatus.loading;
      })
      .addCase(getSharpenProduct.fulfilled, (state, action) => {
        state.status = ActionStatus.succeeded;
        state.data = action.payload;
      })
      .addCase(getSharpenProduct.rejected, (state, action) => {
        state.status = ActionStatus.failed;
        state.error = action.error.message || '';
      })
    }
});


// CREATE REDUCER
export const sharpenProductReducer = sharpenProductSlice.reducer;


// DECLARE THUNKS
export const getSharpenProduct = createAsyncThunk('orderCompletion/getSharpenProduct', async (isbn10: any, thunkAPI) => {
    try {
        if (isbn10) {
            await thunkAPI.dispatch(loadCustomer());
            return await getSharpenProductApiCall(isbn10);
        } else {
            return thunkAPI.rejectWithValue({
                message: 'Missing isbn10.',
                isbn10: isbn10
            });
        }
    } catch (error) {
        return thunkAPI.rejectWithValue({
            error: error,
            isbn10: isbn10
        })
    }
}, {
    condition: ((_args: any, { getState }) => {
        const state = getState() as StoreState;
        return state.sharpenProductState.status === ActionStatus.idle;
    })
});


// MAKE API CALL
async function getSharpenProductApiCall(isbn10: string): Promise<SharpenProduct> {
    const url = new URL(environment().magentoUrl + ShopApi.getSharpenProductMagento.replace(":isbn10", isbn10));
    const token = getCookie(COOKIE_MH_TOKEN);
    return await getResponseData(
        new Request(url.toString(), {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        })
    );
}